// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { formatText } = require('core/i18n').i18n;

class MortgageRequestFormattedRegistryData extends React.Component {
    render() {
        const { immEstate, className } = this.props;
        const province = !!immEstate.get('provinceName') ? formatText('mortgageRequestRegistryData-province', [immEstate.get('provinceName')]) : '';
        const population = !!immEstate.get('populationName') ? `, ${formatText('mortgageRequestRegistryData-population', [immEstate.get('populationName')])}` : '';
        const registerName = !!immEstate.get('registerName') ? `, ${formatText('mortgageRequestRegistryData-registerName', [immEstate.get('registerName')])}` : '';
        const registerFincaNumber = !!immEstate.get('registerFincaNumber') ? `, ${formatText('mortgageRequestRegistryData-registerFincaNumber', [immEstate.get('registerFincaNumber')])}` : '';
        const registerSection = !!immEstate.get('registerSection') ? `, ${formatText('mortgageRequestRegistryData-registerSection', [immEstate.get('registerSection')])}` : '';
        const registerBook = !!immEstate.get('registerBook') ? `, ${formatText('mortgageRequestRegistryData-registerBook', [immEstate.get('registerBook')])}` : '';
        const registerVolume = !!immEstate.get('registerVolume') ? `, ${formatText('mortgageRequestRegistryData-registerVolume', [immEstate.get('registerVolume')])}` : '';
        const registerFolio = !!immEstate.get('registerFolio') ? `, ${formatText('mortgageRequestRegistryData-registerFolio', [immEstate.get('registerFolio')])}` : '';
        const registryData = `${province}${population}${registerName}${registerFincaNumber}${registerSection}${registerBook}${registerVolume}${registerFolio}`;

        return (
            <span className={className}>
                {registryData}
            </span>
        );
    }
}

MortgageRequestFormattedRegistryData.propTypes = {
    immEstate: PropTypes.object.isRequired,
    className: PropTypes.string
};

module.exports = MortgageRequestFormattedRegistryData
